<template>
  <v-dialog fullscreen full-width v-model="loading">
    <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5);">
      <v-layout justify-center align-center>
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-layout>
    </v-container>
  </v-dialog>
</template>
<script>
export default {
  name: "loader",
  data() {
    return {
      loading: true
    };
  }
};
</script>